<template>
  <AppHeader>Create Tickets</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-3">
    <div class="p-3 bg-white shadow-md rounded-2xl">
      <div class="px-2 py-1 mb-2 border-2 rounded-xl border-slate-100">
        <p class="text-lg text-gray-600">Scope</p>
        <select class="w-full mt-2 bg-transparent outline-none" v-model="form.scope">
          <option value="">-- Select Scope --</option>
          <option v-for="(scopeValue, scope) in scopes" :key="scope" :value="scope">{{ scope }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-400" v-if="errors.scope">{{ errors.scope }}</p>
      </div>

      <div class="px-2 py-1 mb-2 border-2 rounded-xl border-slate-100">
        <p class="text-lg text-gray-600">Category</p>
        <select class="w-full mt-2 bg-transparent outline-none" v-model="form.category_id">
          <option value="">-- Select Category --</option>
          <option v-for="category in scopes[form.scope]" :key="category.id" :value="category.id">{{ category.name }}</option>
        </select>

        <div class="m-1 mt-2" v-if="selectedCategory">
          <p class="text-gray-500">{{ selectedCategory.description }}</p>
        </div>
        <p class="w-full mt-1 text-sm text-left text-red-400" v-if="errors.category_id">{{ errors.category_id }}</p>
      </div>

      <div class="px-2 py-1 mb-2 border-2 rounded-xl border-slate-100">
        <p class="text-lg text-gray-600">Description</p>
        <textarea rows="5" class="w-full mt-2 outline-none" placeholder="Enter your Query in detail" v-model="form.description"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-400" v-if="errors.description">{{ errors.description }}</p>
      </div>

      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-lg text-gray-600">Attach Files</p>
        <input class="mt-2 outline-none W-full text-slate-400 file:border-none file:rounded-full file:leading-none file:p-2" accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.csv,.xls,.xlsx" type="file" multiple @change="uploadFiles">
        <p class="w-full mt-1 text-sm text-left text-red-400" v-if="errors.files">{{ errors.files }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button @click="createTicket" class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300">Create Ticket</button>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import mixin from '@/utils/mixin';
import formMixin from '@/utils/mixins/form';

export default {
  name: 'TicketsCreate',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      form: {
        scope: '',
        category_id: '',
        description: null,
        files: null,
      },
      state: 'idle',
      scopes: []
    }
  },

  computed: {
    selectedCategory() {
      return this.scopes[this.form.scope]?.find(category => category.id === this.form.category_id);
    }
  },

  methods: {
    uploadFiles(event){
      this.form.files = Array.from(event.target.files)
    },

    getData() {
      this.state = 'loading';

      this.request('GET', 'tickets/create', null, (resp) => {
        this.state = 'idle';
        this.scopes = resp.data.scopes;
      });
    },

    createTicket() {
      let rules = {
        scope: 'required',
        category_id: 'required|numeric',
        description: 'required',
      };

      if (!this.validateForm(this.form, rules)) return;

      const formData = new FormData();
      formData.append('category_id', this.form.category_id);
      formData.append('description', this.form.description);

      if (this.form.files && this.form.files.length > 0) {
        this.form.files.forEach((f, i) => formData.append(`files[${i}]`, f));
      }

      this.state = 'loading';

      this.request('POST', 'tickets/create', formData, (resp) => {
        this.state = 'idle';

        alert(resp.message ? resp.message : 'Unable to process your request, try again!');

        if (resp.success) {
          this.$router.push({ name: 'TicketsIndex' });
        }
      });
    },
  },

  created() {
    this.getData();
  },
}
</script>
